import styles from "./styles.module.css";

export const CGU: React.FC = () => {
  return (
    <div className={styles.container}>
      <h1>Conditions Générales d'Utilisation (CGU)</h1>
      <p className="update-date">Dernière mise à jour : 25/03/2025</p>
      <p>
        Les présentes Conditions Générales d'Utilisation (CGU) régissent l'accès
        et l'utilisation du site
        <a
          href="https://cardonize.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          {" "}
          https://cardonize.com
        </a>
        , ainsi que les services proposés par Cardonize (ci-après
        "l'Entreprise"). En utilisant ce site, vous acceptez sans réserve les
        présentes CGU.
      </p>

      <h2>1. Définitions</h2>
      <ul>
        <li>
          <strong>Utilisateur</strong> : Toute personne physique ou morale qui
          accède et utilise le Site pour acheter, vendre, ou créer des
          photocards.
        </li>
        <li>
          <strong>Vendeur</strong> : Utilisateur qui met en ligne des photos
          pour créer des photocards destinées à la vente.
        </li>
        <li>
          <strong>Acheteur</strong> : Utilisateur qui achète des photocards
          créées par d'autres utilisateurs.
        </li>
      </ul>

      <h2>2. Accès au Site</h2>
      <ul>
        <li>
          2.1. L'accès au Site est libre, mais certaines fonctionnalités peuvent
          nécessiter l'inscription d'un compte utilisateur.
        </li>
        <li>
          2.2. L'Utilisateur s'engage à fournir des informations exactes et à
          jour lors de l'inscription. L'Utilisateur est responsable de la
          sécurité et de la confidentialité de ses identifiants.
        </li>
      </ul>

      <h2>3. Utilisation du Site</h2>
      <ul>
        <li>
          3.1. L'Utilisateur peut utiliser le Site pour consulter, créer,
          acheter, vendre, ou imprimer des photocards, conformément aux
          présentes CGU.
        </li>
        <li>
          3.2. L'Utilisateur s'engage à ne pas violer les droits d'auteur ou
          d'autres droits de propriété intellectuelle, à ne pas publier de
          contenu illicite ou nuisible.
        </li>
      </ul>

      <h2>4. Responsabilité de l'Utilisateur</h2>
      <ul>
        <li>
          4.1. L'Utilisateur est responsable de l'utilisation qu'il fait du Site
          et des contenus qu'il soumet. Il s'engage à respecter les lois en
          vigueur dans son pays de résidence.
        </li>
        <li>
          4.2. L'Utilisateur s'engage à ne pas utiliser le Site pour des
          activités illégales, y compris le téléchargement de contenu protégé
          par des droits d'auteur sans autorisation.
        </li>
      </ul>

      <h2>5. Responsabilité de l'Entreprise</h2>
      <ul>
        <li>
          5.1. L'Entreprise met tout en œuvre pour assurer la sécurité et le bon
          fonctionnement du Site. Cependant, elle ne peut garantir l'absence
          d'interruption ou de défaillance technique.
        </li>
        <li>
          5.2. L'Entreprise ne pourra être tenue responsable des pertes
          indirectes, notamment celles liées à la disponibilité ou à la qualité
          des services.
        </li>
      </ul>

      <h2>6. Protection des Données Personnelles</h2>
      <ul>
        <li>
          6.1. L'Entreprise collecte et traite les données personnelles des
          utilisateurs conformément à la législation en vigueur, notamment le
          RGPD.
        </li>
        <li>
          6.2. L'Utilisateur peut exercer ses droits d'accès, de rectification
          et de suppression des données en contactant l'Entreprise via{" "}
          <a href="mailto:contact@cardonize.com">contact@cardonize.com</a>.
        </li>
      </ul>

      <h2>7. Modification des CGU</h2>
      <p>
        L'Entreprise se réserve le droit de modifier les présentes CGU à tout
        moment. Les modifications seront publiées sur le Site. En continuant
        d'utiliser le Site, l'Utilisateur accepte les nouvelles CGU.
      </p>

      <h2>8. Loi Applicable et Litiges</h2>
      <p>
        Les présentes CGU sont régies par la loi française. En cas de litige,
        les parties tenteront de résoudre leur différend à l'amiable. À défaut,
        les tribunaux compétents de [ville ou région] seront seuls compétents.
      </p>
    </div>
  );
};
